import React, {Component} from 'react'
import {connect} from 'react-redux'
import LoginActions from '../reducers/login/LoginRedux'
import '../assets/App.css'
import {
  Row,
  Col,
  Grid,
  Panel,
  Button,
  PanelBody,
  PanelContainer,
  FormControl,
  InputGroup,
  Icon,
} from "@sketchpixy/rubix";
import { ERROR_MESSAGES, FIELD_STATUSES } from "../utils";
import NotificationSystem from "react-notification-system";
import packageJson from "../../package.json";

class SplashPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      authenticate: !!this.props.loginToken,
      emailError: {
        status: null,
        message: "",
      },
      passwordError: {
        status: null,
        message: "",
      },
      loginError: "",
    };
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
  }

  _addNotification = (message, type, title) => {
    this._notificationSystem.clearNotifications();
    this._notificationSystem.addNotification({
      message,
      title: title,
      level: type,
      autoDismiss: 2,
    });

    if (type === "error") {
      this.setState({
        emailError: {
          status: FIELD_STATUSES.ERROR,
          message: "",
        },
        passwordError: {
          status: FIELD_STATUSES.ERROR,
          message: "",
        },
      });
    }
  };

  componentWillReceiveProps(newProps) {
    // if (newProps.loginToken) {
    //     this.setState({authenticate: true})
    // }
    const { fetching, error, forgotPasswordMessage } = newProps;
    if (newProps.loginToken) {
      this.setState({ authenticate: true });
    }
    if (!fetching && !error && forgotPasswordMessage) {
      this._addNotification(
        forgotPasswordMessage,
        "success",
        "Success Message: "
      );
    } else if (!fetching && error) {
      this._addNotification(error, "error", "Error Message: ");
    }
  }

  actions = (link) => {
    const { history } = this.props;
    history.push(link);
  };

  handleInputChange = ({ target: { name, value } }) => {
    this.setState({
      [name]: value,
      emailError: {
        status: null,
        message: "",
      },
      passwordError: {
        status: null,
        message: "",
      },
    });
  };

  handleFieldValidations = () => {
    const { email } = this.state;
    let [emailError, errorExist] = [{}, {}, false];
    if (!email) {
      emailError.status = FIELD_STATUSES.ERROR;
      emailError.message = ERROR_MESSAGES.USER_ERROR_MESSAGE;
      errorExist = true;
    }
    return { emailError, errorExist };
  };

  forgotPassword = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const { emailError, errorExist } = this.handleFieldValidations();
    if (errorExist) {
      this.setState({
        emailError,
      });
    }
    const { email } = this.state;
    if (email) {
      this.props.forgotPasswordRequest(email);
    }
  };

  render() {
    const {
      authenticate,
      email,
      password,
      emailError: { status: emailStatus, message: emailError },
      passwordError: { status: passwordStatus, message: passwordError },
    } = this.state;

    return (
      <div>
        <div style={{ paddingLeft: "35px", marginTop: "10px" }}>
          <a href="/">
            <img
              style={{ margin: "0" }}
              src="/imgs/app/vbgTextIcon.svg"
              width="180"
              alt=""
              height="70"
            />
          </a>
        </div>
        <div
          style={{
            backgroundColor: "rgb(247, 247, 247)",
            paddingTop: "10px",
            paddingBottom: "10px",
            marginLeft: "40px",
            marginRight: "40px",
            marginTop: "10px",
          }}
        >
          <div className="text-center fg-darkblue">
            <h1 className="heading-main">Email linked with Fastvet</h1>

            <div style={{ margin: "0 auto", width: "50%", marginTop: "25px", paddingBottom: "25px" }}>
              <InputGroup bsSize="large" style={{ width: "100%" }}>
                <label
                  style={{
                    fontSize: "18px",
                    color: "#022144",
                    textAlign: "left",
                  }}
                >
                  Enter your email{" "}
                </label>
                <FormControl
                  autoFocus
                  type="email"
                  className="border-focus-blue required border-blue input1"
                  name="email"
                  onChange={this.handleInputChange}
                  style={{ width: "100%" }}
                  value={email}
                />
              </InputGroup>

              <Button
                lg
                type="button"
                name={"addNew"}
                bsStyle="primary"
                onClick={this.forgotPassword}
                className="bg-darkblue full-button"
              >
                Send
              </Button>
            </div>
          </div>

          <NotificationSystem ref="notificationSystem" />
        </div>
        <div
          style={{
            bottom: "10",
            width: "100%",
            textAlign: "center",
            marginTop: "20px",
          }}
        >
          <span>
            &copy; 2023 Veteran Benefits Guide
            <br />
            App version: {packageJson.version}
            <br />
          </span>
        </div>
      </div>
    );
  }
}

const
mapStateToProps = ({login}) => {
    const {loginToken, error, fetching, role, forgotPasswordMessage} = login
    return {loginToken, error, fetching, role, forgotPasswordMessage}
}

const
    mapDispatchToProps = dispatch => ({
        forgotPasswordRequest: (email) => {
            dispatch(LoginActions.createForgotRequest(email))
        },
    })

export default connect(mapStateToProps, mapDispatchToProps)(SplashPage)
